export default {
  'apiCallResponse.title': 'Mapeos Respuesta API',
  'apiCallResponse.mapping': 'Mapeo',
  'apiCallResponse.addMapping': 'Agregar mapeo',
  'apiCallResponse.noMappings': 'No hay mapeos configurados.',

  'apiCallResponse.form.responseHttpStatusCode': 'Código Respuesta Http',
  'apiCallResponse.form.responseParameterPosition': 'Posición Parámetro Respuesta',
  'apiCallResponse.form.valueDestination': 'Destino Valor',

  'apiCallResponse.form.form': 'Formulario',
  'apiCallResponse.form.field': 'Campo',
  'apiCallResponse.form.variable': 'Variable',
  'apiCallResponse.form.parameterCodification': 'Parámetro de Codificación',

  'apiCallResponse.form.parameterValueFilterComparisonOperator': 'Operador para Filtro',
  'apiCallResponse.form.parameterValueFilter': 'Valor Filtro Parámetro',

  'apiCallResponse.form.formFieldValueDestination': 'Destino Valor Campo',

  'apiCallResponse.form.tableParameterName': 'Nombre Parámetro Lista',
  'apiCallResponse.form.parameterName': 'Nombre Parámetro',
  'apiCallResponse.form.attachmentFileName': 'Nombre del Adjunto',
  'apiCallResponse.form.attachmentContentType': 'Tipo de Contenido',

  'apiCallResponse.form.select.FormField': 'Formulario / Campo',
  'apiCallResponse.form.select.Variable': 'Variable',
  'apiCallResponse.form.select.EntityField': 'Campo de Entidad',
  'apiCallResponse.form.select.InstanceName': 'Nombre Solicitud',
  'apiCallResponse.form.select.OperationObservations': 'Observaciones de la Operación',
  'apiCallResponse.form.select.OperationUserEmail': 'Correo Usuario que realiza la Operación',
  'apiCallResponse.form.select.OperationIsApprovalOrReject': 'Indicador Aprobación / Rechazo',

  'apiCallResponse.form.select.FieldValue': 'Valor a Mostrar',
  'apiCallResponse.form.select.FieldSearchValue': 'Valor de Búsqueda',

  'apiCallResponse.form.select.None': 'Sin Codificación',
  'apiCallResponse.form.select.ByteArray': 'Arreglo de Bytes',
  'apiCallResponse.form.select.Base64String': 'Cadena Base64',
  'apiCallResponse.form.select.ZipByteArray': 'Fichero Zip - Arreglo de Bytes',
  'apiCallResponse.form.select.ZipBase64String': 'Fichero Zip - Cadena Base64',
  'apiCallResponse.form.select.HttpBodyBinaryData': 'Binario Codificado en Cuerpo de la Petición',

  'apiCallResponse.form.select.Header': 'Cabecera',
  'apiCallResponse.form.select.Url': 'Url',
  'apiCallResponse.form.select.FormData': 'Formulario',
  'apiCallResponse.form.select.BodyJson': 'Cuerpo(JSON)',
  'apiCallResponse.form.select.XWwwFormUrlEncoded': 'Formulario Url Codificada',
  'apiCallResponse.form.select.Authorization': 'Autorización',
  'apiCallResponse.form.select.BodyText': 'Cuerpo(Texto)',
  'apiCallResponse.form.select.FormFileData': 'Formulario / Fichero',

  'apiCallResponse.form.select.Equal': 'Igual',
  'apiCallResponse.form.select.NotEqual': 'Distinto',
  'apiCallResponse.form.select.GreaterThan': 'Mayor que',
  'apiCallResponse.form.select.GreaterThanOrEqual': 'Mayor o igual que',
  'apiCallResponse.form.select.LessThan': 'Menor que',
  'apiCallResponse.form.select.LessThanOrEqual': 'Menor o igual que',
  'apiCallResponse.form.select.Contains': 'Contiene',
  'apiCallResponse.form.select.NotContains': 'No Contiene',
  'apiCallResponse.form.select.IsNull': 'Es Nulo',
  'apiCallResponse.form.select.IsNotNull': 'No Es Nulo',
};
